import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const API_BASE_URL = window.$atf_config.api; 

export const apiSlice = createApi({
  baseQuery: fetchBaseQuery({ 
    baseUrl: API_BASE_URL,
    mode: 'cors',
  }),
  endpoints: () => ({}),
  tagTypes: [
    'atf_poi', 'atf_region', 
    'atf_state', 'atf_category'
],
  reducerPath: 'api'
})

export async function fetchAllPaginated(baseQuery, endpoint, params = {}, perPage = 100, concurrency = 2, onProgress) {
    try {
      const fetchPage = page => baseQuery({
          url: endpoint,
          params: { ...params, per_page: perPage, page },
      });
      const firstPage = await fetchPage(1);
      if (firstPage.error) return { error: firstPage.error };

      const totalPages = parseInt(firstPage.meta?.response?.headers.get('X-WP-TotalPages') || '1', 10);
      const totalItems = parseInt(firstPage.meta?.response?.headers.get('X-WP-Total') || firstPage.data.length, 10);
      let allData = firstPage.data;
      let completedPages = 1;
      let loadedItems = firstPage.data.length;
      onProgress?.({completedPages, totalPages, loadedItems, totalItems});

      const fetchPageWithProgress = async page => {
        const result = await fetchPage(page);
        if(!result.error){
          completedPages++;
          loadedItems += result.data.length;
          onProgress?.({completedPages, totalPages, loadedItems, totalItems});
        }
        return result;
      };

      for(let page = 2; page <= totalPages; page += concurrency){
        const pages = Array.from({length: Math.min(concurrency, totalPages - page + 1)}, (_, i) => page + i);
        const results = await Promise.all(pages.map(fetchPageWithProgress));
        const failed = results.find(result => result.error);
        if(failed) return { error: failed.error };
        allData = allData.concat(...results.map(result => result.data));
      }

      return { data: allData };
    } catch (err) {
      return { error: err };
    }
  }
